import axios from 'axios';
import apiConfig from '../../api.config';
import constants from '../../../constants';
import storage from '../../../storage';

export default function findHotelInvoiceByInvoiceInternalId({ hotelId, invoiceInternalId }) {
  const {
    host,
    URIs: { findHotelInvoiceByInvoiceInternalId },
  } = apiConfig;

  const uri = `${host}${findHotelInvoiceByInvoiceInternalId}`.replace(':hotelInvoiceId', invoiceInternalId);

  const storedCredentials = JSON.parse(storage.get(constants.AUTH.USER_KEY));
  
  return axios
    .post(uri, {
      data: {
        hotelId: hotelId || 0,
        hotelReference: 'civitfun',
        accessToken: storedCredentials.accessToken,
      }
    })
    .then(res => {
      return res.data;
    });
}
